// extracted by mini-css-extract-plugin
export default {"tooltip":"JIMRl","tooltip-content":"q1Im1","arrow":"vgLVI"};